export const mockGetPaymentPageData = {
  data: {
    success: true,
    network: {
      ID: 2,
      name: "Test Net",
      shortname: "testnet",
      city: "Sciota",
      state: "PA",
      iconURL:
        "https://s3-us-west-2.amazonaws.com/dev-photos.flocknote.com/everyone/icon.png",
      website: null,
      isCardAllowed: true,
      isACHAllowed: true,
      contactEmail: "help@flocknote.com",
    },
    fund: {
      ID: 12,
      description: "Signup - All New Test Event",
      details: "",
      fundColor: "E87E04",
      colorScheme: ["E87E04", "EC9E11", "FFD132"],
      createdBy: {
        name: "Super Admin",
        photoURL: null,
      },
      paymentPageSettings: {
        suggestedAmounts: [25, 50, 100],
        paymentType: "Signup",
        hideConfetti: false,
        memoEnabled: false,
        confirmationMessage: "",
      },
    },
    modifyPayment: {
      paymentID: null,
      originalAmount: null,
      paymentAlreadyCanceled: false,
      paymentAlreadyCompleted: false,
      paymentMethodID: null,
    },
    noteInfo: {},
    user: {
      ID: 2,
      loginLevel: "full",
      name: "Super Admin",
      photoURL: null,
      phoneNumber: "5552396176",
      email: "superadmin@testnet.com",
      hasExistingPledge: false,
      billingAddress: {
        zip: "12345",
      },
      sharableWith: [],
      paymentMethodsCanBeShared: false,
      hasExistingRecurringGiftForFund: false,
    },
    paymentMethods: [
      {
        ID: 1,
        paymentType: "card",
        cardType: "visa",
        nickname: "",
        last4: "1111",
        expirationMonth: "12",
        expirationYear: "34",
        accountHolderName: "Super Admin",
        zip: "12345",
        hasOtherOwner: false,
        owner: {
          ID: 2,
          fname: "Super",
          lname: "Admin",
          photo: null,
        },
        isDefaultPaymentMethod: true,
        hasRecurringPayment: false,
        sharedWithOtherHoH: true,
        isAvailableAsSavedPaymentMethod: true,
        isUsedForRecurringGift: false,
        mounted: true,
      },
    ],
    appID: "864406",
    environment: "stage-api",
    campaign: [],
    suggestedRecurring: {
      startDate: "",
      endDate: "",
      interval: "",
    },
    hasRecurringOn: true,
    maxSecondsToPollPaymentStatus: 5,
    signupName: "All New Test Event",
  },
  isApp: false,
  userID: 2,
};
